import { render, staticRenderFns } from "./settingInterface.vue?vue&type=template&id=3b032210&scoped=true&"
import script from "./settingInterface.vue?vue&type=script&lang=js&"
export * from "./settingInterface.vue?vue&type=script&lang=js&"
import style0 from "./settingInterface.vue?vue&type=style&index=0&id=3b032210&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b032210",
  null
  
)

export default component.exports